module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-gafam2.f14822c9.png";